/*
 * One place for custom analytics events.
 *
 * Preserve the existing destinations: GTM's event-object data layer, Google's
 * gtag function, and Shopify's custom-event bus. Queuing a command does
 * not prove that a configured collector consumed it or that consent allows it.
 * Do not install/configure another Google tag here: Shopify owns that setup.
 *
 * Every path swallows its own errors. A broken analytics call must never be
 * the reason a form stops working.
 */
// Hold only in memory until the existing Google app exposes its function.
// Its synchronous initialization sets consent/config before this timer runs.
var offshoreGooglePending = [];
var offshoreGoogleTimer = null;
var offshoreGoogleTicks = 0;
function offshoreFlushGoogle() {
  offshoreGoogleTimer = null;
  if (typeof window.gtag === 'function') {
    var pending = offshoreGooglePending;
    offshoreGooglePending = [];
    pending.forEach(function (entry) {
      try { window.gtag('event', entry[0], entry[1]); } catch (error) { /* No retry after dispatch. */ }
    });
    offshoreGoogleTicks = 0;
  } else if (++offshoreGoogleTicks < 60) {
    offshoreGoogleTimer = setTimeout(offshoreFlushGoogle, 1000);
  } else {
    offshoreGooglePending = [];
    offshoreGoogleTicks = 0;
  }
}
function offshoreSendGoogle(name, data) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, data);
  } else {
    if (offshoreGooglePending.length < 100) offshoreGooglePending.push([name, Object.assign({}, data)]);
    if (offshoreGoogleTimer === null) offshoreGoogleTimer = setTimeout(offshoreFlushGoogle, 1000);
  }
}
window.addEventListener('pagehide', function () {
  if (offshoreGoogleTimer !== null) clearTimeout(offshoreGoogleTimer);
  offshoreGoogleTimer = null;
  offshoreGooglePending = [];
  offshoreGoogleTicks = 0;
});

window.offshoreTrack = function offshoreTrack(name, payload) {
  var data = payload || {};
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data));
  } catch (error) {
    /* One destination must not prevent the others from receiving the event. */
  }
  try {
    offshoreSendGoogle(name, data);
  } catch (error) {
    /* deliberately silent */
  }
  try {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      var published = window.Shopify.analytics.publish(name, data);
      if (published && typeof published.catch === 'function') {
        published.catch(function () { /* Analytics must not break the page. */ });
      }
    }
  } catch (error) {
    /* deliberately silent */
  }
};

/*
 * Native Shopify contact forms post and reload, so by the time the success
 * message renders the fields the lead filled in are gone. Stash the
 * qualifying answers on the way out and pick them up on the way back in.
 */
var LEAD_KEY = 'offshore:lead';

document.addEventListener(
  'submit',
  function (event) {
    var form = event.target.closest && event.target.closest('[data-lead-form]');
    if (!form) return;
    try {
      var timing = form.querySelector('[name="contact[timing]"]');
      var equipment = form.querySelector('[name="contact[equipment]"]');
      sessionStorage.setItem(
        LEAD_KEY,
        JSON.stringify({
          timing: timing ? timing.value : '',
          has_equipment: equipment ? equipment.value.trim().length > 0 : false,
        })
      );
    } catch (error) {
      /* deliberately silent */
    }
  },
  true
);

window.offshoreTrackLead = function offshoreTrackLead(payload) {
  var stashed = {};
  try {
    var raw = sessionStorage.getItem(LEAD_KEY);
    if (raw) {
      stashed = JSON.parse(raw);
      sessionStorage.removeItem(LEAD_KEY);
    }
  } catch (error) {
    /* deliberately silent */
  }
  window.offshoreTrack('lead_submit', Object.assign({}, payload || {}, stashed));
};

/*
 * This file is deferred, so anything that fired during parse is waiting in
 * the queue the stubs in theme.liquid filled. Drain it in order.
 */
(window.offshoreQueue || []).forEach(function (entry) {
  if (entry[0] === 'lead') window.offshoreTrackLead(entry[1]);
  else window.offshoreTrack(entry[1], entry[2]);
});
window.offshoreQueue = [];
